import React from "react";
import icon1 from "../../assets/img/icons/p1.png";
import icon2 from "../../assets/img/icons/p2.png";
import icon3 from "../../assets/img/icons/p3.png";
import { Link } from "react-router-dom";

const Pricing = () => {
  return (
    <section className="pricing-wrapper section-padding pricing-bg">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <div className="block-contents text-center">
              <div className="section-title">
                <span>Locations</span>
                <h2>Our Offices & Factory</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="single-pricing-plan">
              <div className="package-head">
                <div className="icon">
                  <img src={icon1} alt="" />
                </div>
                <div className="package-title">
                  <h6>Factory:</h6>
                  {/* <h2>$49.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>PANCHASAR ROAD,</span>
                <span>MORBI – 363 641 (Gujarat) INDIA</span>
                <span>Ph No: +91-7600048000</span>
                {/* <span>Fax No: +91-2822-250756</span> */}
            
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="single-pricing-plan">
              <div className="package-head">
                <div className="icon">
                  <img src={icon3} alt="" />
                </div>
                <div className="package-title">
                  <h6>Rajkot Sales Office :</h6>
                  {/* <h2>$89.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>G-1 MARKETING YARD,  <br></br> RAJKOT – 360 004</span>
                <span>Ph No: +91-9925022545</span>
                {/* <span>Fax No: +91-281-2701219</span> */}
                {/* <span>Cell No: +91-9426999999</span> */}
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-12"></div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="single-pricing-plan  ">
              <div className="package-head">
                <div className="icon">
                  <img src={icon2} alt="" />
                </div>
                <div className="package-title">
                  <h6>Corporate Office :</h6>
                  {/* <h2>$69.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>SHREE GITA GROUP</span>
                <span>C-301 IMPERIAL HEIGHTS,</span>
                <span>OPP BIG BAZAAR, 150 Ft RING ROAD,</span>
                <span>RAJKOT – 360 005(Gujarat) INDIA</span>
                {/* <span>Ph No: +91-281-2579901 / 2579902</span>
                <span>Fax No: +91-281-2579903</span> */}
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-12"></div>

          <div className="col-lg-6 col-md-6 col-12" style={{display:'none'}}>
            <div className="single-pricing-plan" style={{
              paddingBottom:"80px"
            }}>
              <div className="package-head">
                <div className="icon">
                  <img src={icon3} alt="" />
                </div>
                <div className="package-title">
                  <h6>Branch Office:</h6>
                  {/* <h2>$89.00</h2> */}
                </div>
              </div>
              <div className="package-features">
                <span>13-14 PARSHWA COMPLEX,</span>
                <span>CIVIL HOSPITAL ROAD,</span>
                <span>MORBI – 363 641</span>
                <span>(Gujarat) INDIA</span>
                <span>Cell No: +91-9426999999</span>
              </div>
              {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Pricing;
